import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-[20px] md:tw-justify-between tw-flex-wrap category-header" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]" }
const _hoisted_3 = { class: "tw-flex tw-gap-[15px]" }

import { ref, Ref, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentCategoryHeader',
  props: {
  /** The title of category */
  title: {
    type: String,
    default: "",
  },
  isFlashing: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const containerRef: Ref<HTMLElement | null> = ref(null);


watch(props, () => {
  if (props.isFlashing) {
    setTimeout(() => {
      containerRef.value &&
        containerRef.value.classList.remove("animate__flash");
      setTimeout(() => {
        containerRef.value &&
          containerRef.value.classList.add("animate__flash");
      }, 100);
    }, 1000);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      "data-cy": "assessment-category-header",
      class: _normalizeClass(`tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58] tw-capitalize animate__animated ${
        __props.isFlashing ? ' animate__flash' : ''
      } ${__props.className}`)
    }, _toDisplayString(__props.title), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})